module.exports = __webpack_public_path__ + "static/media/ic_chrome_grey.3593c575.svg";